import {HttpService} from "./http";

class ConsultationService extends HttpService {
    public constructor() {
        super("/client-app/client/consultations");
    }

    public index(filters: string | object | null = null): Promise<any> {
        return this.http
            .get(`${this.route}/`, {
                params: filters
            })
            .then(this.handleResponse.bind(this))
            .catch(this.handleError.bind(this));
    }

    public mostRecent(): Promise<any> {
        return this.http
            .get(this.route + "/most-recent")
            .then(this.handleResponse.bind(this))
            .catch(this.handleError.bind(this));
    }

    public show(id: string): Promise<any> {
        return this.http
            .get(this.route + "/" + id)
            .then(this.handleResponse.bind(this))
            .catch(this.handleError.bind(this));
    }

    public create(data: any): Promise<any> {
        return this.http
            .post(this.route, data)
            .then(this.handleResponse.bind(this))
            .catch(this.handleError.bind(this));
    }

    public update(id: string, data: any): Promise<any> {
        return this.http
            .put(this.route + "/" + id, {data: data})
            .then(this.handleResponse.bind(this))
            .catch(this.handleError.bind(this));
    }
}

export const consultationService: ConsultationService = new ConsultationService();
